module.exports = __webpack_public_path__ + "static/media/EndocardialSegmentation_1-1440w.93024941.jpg";